import React from 'react'
import { createTheme, StyledEngineProvider, ThemeOptions } from '@mui/material'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { PropsWithChildren, useMemo } from 'react'
import defaultMuiThemeOptions from './DefaultTheme'
import { mergeTheme } from './mergeTheme'

export type ThemeProviderProps = PropsWithChildren<{
  theme?: ThemeOptions
  injectFirst?: boolean
}>

export const ThemeProvider = ({
  theme = defaultMuiThemeOptions,
  injectFirst,
  children,
}: ThemeProviderProps): React.ReactNode => {
  const mergedTheme = useMemo(() => mergeTheme(theme), [theme])
  const muiTheme = createTheme(mergedTheme)
  return (
    <StyledEngineProvider injectFirst={injectFirst}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </StyledEngineProvider>
  )
}
